"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const ComputeVatError_1 = require("./types/ComputeVat/ComputeVatError");
const ComputeVatError_2 = require("./types/ComputeVat/ComputeVatError");
const ComputeVatError_3 = require("./types/ComputeVat/ComputeVatError");
const ComputeVatError_4 = require("./types/ComputeVat/ComputeVatError");
const ComputeVatError_5 = require("./types/ComputeVat/ComputeVatError");
const ComputeVatError_6 = require("./types/ComputeVat/ComputeVatError");
const ComputeVatError_7 = require("./types/ComputeVat/ComputeVatError");
const ListCountriesError_1 = require("./types/ListCountries/ListCountriesError");
const ListCountriesError_2 = require("./types/ListCountries/ListCountriesError");
const ListCountriesError_3 = require("./types/ListCountries/ListCountriesError");
const ListCountriesError_4 = require("./types/ListCountries/ListCountriesError");
const ListCountriesError_5 = require("./types/ListCountries/ListCountriesError");
const VerifyVatNumberError_1 = require("./types/VerifyVatNumber/VerifyVatNumberError");
const VerifyVatNumberError_2 = require("./types/VerifyVatNumber/VerifyVatNumberError");
const VerifyVatNumberError_3 = require("./types/VerifyVatNumber/VerifyVatNumberError");
const VerifyVatNumberError_4 = require("./types/VerifyVatNumber/VerifyVatNumberError");
const VerifyVatNumberError_5 = require("./types/VerifyVatNumber/VerifyVatNumberError");
const VerifyVatNumberError_6 = require("./types/VerifyVatNumber/VerifyVatNumberError");
const VerifyVatNumberError_7 = require("./types/VerifyVatNumber/VerifyVatNumberError");
exports.errors = {
    ComputeVat: {
        InvalidParameterError: ComputeVatError_2.InvalidParameterError,
        UnauthorizedError: ComputeVatError_3.UnauthorizedError,
        NotFoundError: ComputeVatError_4.NotFoundError,
        InternalServerError: ComputeVatError_5.InternalServerError,
        BadGatewayError: ComputeVatError_6.BadGatewayError,
        GatewayTimeoutError: ComputeVatError_7.GatewayTimeoutError,
        GenericError: ComputeVatError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListCountries: {
        UnauthorizedError: ListCountriesError_2.UnauthorizedError,
        InternalServerError: ListCountriesError_3.InternalServerError,
        BadGatewayError: ListCountriesError_4.BadGatewayError,
        GatewayTimeoutError: ListCountriesError_5.GatewayTimeoutError,
        GenericError: ListCountriesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    VerifyVatNumber: {
        InvalidParameterError: VerifyVatNumberError_2.InvalidParameterError,
        UnauthorizedError: VerifyVatNumberError_3.UnauthorizedError,
        NotFoundError: VerifyVatNumberError_4.NotFoundError,
        InternalServerError: VerifyVatNumberError_5.InternalServerError,
        BadGatewayError: VerifyVatNumberError_6.BadGatewayError,
        GatewayTimeoutError: VerifyVatNumberError_7.GatewayTimeoutError,
        GenericError: VerifyVatNumberError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ComputeVatError: {
        InvalidParameterError: ComputeVatError_2.InvalidParameterError,
        UnauthorizedError: ComputeVatError_3.UnauthorizedError,
        NotFoundError: ComputeVatError_4.NotFoundError,
        InternalServerError: ComputeVatError_5.InternalServerError,
        BadGatewayError: ComputeVatError_6.BadGatewayError,
        GatewayTimeoutError: ComputeVatError_7.GatewayTimeoutError,
        GenericError: ComputeVatError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListCountriesError: {
        UnauthorizedError: ListCountriesError_2.UnauthorizedError,
        InternalServerError: ListCountriesError_3.InternalServerError,
        BadGatewayError: ListCountriesError_4.BadGatewayError,
        GatewayTimeoutError: ListCountriesError_5.GatewayTimeoutError,
        GenericError: ListCountriesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    VerifyVatNumberError: {
        InvalidParameterError: VerifyVatNumberError_2.InvalidParameterError,
        UnauthorizedError: VerifyVatNumberError_3.UnauthorizedError,
        NotFoundError: VerifyVatNumberError_4.NotFoundError,
        InternalServerError: VerifyVatNumberError_5.InternalServerError,
        BadGatewayError: VerifyVatNumberError_6.BadGatewayError,
        GatewayTimeoutError: VerifyVatNumberError_7.GatewayTimeoutError,
        GenericError: VerifyVatNumberError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
